module.exports = __webpack_public_path__ + "static/media/ill_age_set.6f60993a.png";